import React from 'react';

export default function Footer() {
    return (
        <div
            data-testid="universal-footer"
            dangerouslySetInnerHTML={{
                __html: `<!--# block name="footer_fallback" --><!--# endblock --><!--# include virtual="/__universal/footer.html" stub="footer_fallback" -->`
            }}
        />
    );
}
